import { ColDef, ValueFormatterParams } from '@ag-grid-community/core'
import { NfColumnTypes, NfGridOptions } from '@northfork/ag-grid'
import { NgGridComponents } from '@northfork/ag-grid-angular'
import { DisplayTimeFormat, formatDate } from '@northfork/basics'
import formatInTimeZone from 'date-fns-tz/formatInTimeZone'
import { heliosDefaultColWidth } from './default'

/**
 * For testing, this needs to be overriden
 */
export const LOCALE = Intl.DateTimeFormat().resolvedOptions().locale
/**
 * Dynamically import the locale for the current user. This translates the date-fns timezone
 * into the correct short timezone. For example, "America/New_York" becomes "EST" for en-US
 * and "EDT" for en-GB
 * and "IST" for en-IN
 */
const getLocale = () => {
  return import(`date-fns/locale/${LOCALE}/index.js`)
}

/**
 * This is where the magic happens to get the timezone for the current user
 */
const getTimeZone = async () => {
  const importedLocale = await getLocale()
  const currentLongTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const timeZone = formatInTimeZone(new Date(), currentLongTimeZone, 'zzz', {
    locale: importedLocale,
    timeZone: currentLongTimeZone,
  })
  return timeZone
}

export let timeZone = ''

/**
 * Helios is just slow enough to load where this will never be a race condition
 */
getTimeZone().then(tz => {
  timeZone = tz
})

/** DisplayTimeFormatter for displaying date-time objects as simple timestamps */
export const timeFormatter = (params: ValueFormatterParams) => {
  const date = formatDate(params.value, DisplayTimeFormat, 'HH:mmXXX')

  return date ? `${date} ${timeZone}` : ''
}

export const HsTimeColDef: ColDef = {
  ...(NfGridOptions.columnTypes?.[NfColumnTypes.Time] ?? {}),
  filter: NgGridComponents.timeFilter,
  filterParams: {},
  valueFormatter: timeFormatter,
  width: heliosDefaultColWidth.DateCol,
}
